import { useState, useEffect } from 'react';
import { Loader } from '@googlemaps/js-api-loader';
import { useConfigContext } from 'store';

const useGoogleMaps = () => {
    const { googleMapsApiKey } = useConfigContext();
    const [googleMaps, setGoogleMaps] = useState({});

    useEffect(() => {
        if (googleMapsApiKey?.length > 0) {
            const loader = new Loader({
                apiKey: googleMapsApiKey,
                libraries: ['places', 'geometry'],
                language: 'zh-TW'
            });
            loader.load().then((google) => {
                const geocoder = new google.maps.Geocoder();
                setGoogleMaps({ ...google.maps, geocode: geocoder.geocode });
            });
        }
    }, [googleMapsApiKey]);
    useEffect(() => () => {
        const el = document.querySelector('.pac-container');
        el?.remove();
    }, []);

    return googleMaps;
};

export default useGoogleMaps;
